export default {
  visible: (state) => state.visible,
  type: (state) => state.type,
  title: (state) => state.title,
  message: (state) => state.message,
}
